import {
  REQUEST_WEDDING_LIST
} from './mutation-types'


import axiosInst from '@/utility/axiosInst'

export default {

  requestWeddingList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/invitation/wedding-list", {
      params: {
        page: currentPage,
        searchType : searchType,
        searchWord : searchWord,
      }
    }).then((res) => {
      commit(REQUEST_WEDDING_LIST, res.data)
    })
  },


}